import { CursorQuery, Paginated } from '../../common/pagination.js';
import { AppealDecideInput, AppealInput, AppealView } from './schemas.js';
export const adminAppealsRoutes = {
    appeals: {
        method: 'GET',
        path: '/admin/appeals',
        query: CursorQuery,
        response: Paginated(AppealView),
    },
    decideAppeal: {
        method: 'POST',
        path: '/admin/appeals/:appealId',
        body: AppealDecideInput,
        response: AppealView,
    },
};
/** Member-side appeal (FR-SET-09) — lives in the public manifest. */
export const appealRoute = {
    method: 'POST',
    path: '/me/appeals',
    body: AppealInput,
    response: AppealView,
};
//# sourceMappingURL=routes.js.map